<app-paineis-selecao-checkboxes
  [itensEsquerda]="itensEsquerda"
  [itensDireita]="itensDireita"
  [tituloEsquerda]="'Papéis'"
  [tituloSemSelecao]="'Selecione um papel'"
  [tituloDireita]="tituloDireita"
  [mensagemSemSelecao]="'Selecione um papel na lista ao lado para editar suas permissões.'"
  [salvando]="salvando"
  [salvarDesabilitado]="papelSelecionadoEhAdmin"
  (itemSelecionado)="onItemSelecionado($event)"
  (toggleItem)="onToggleItem($event)"
  (salvarClick)="onSalvar($event)">
</app-paineis-selecao-checkboxes>
